export default __webpack_public_path__ + "static/media/filter.afae8a6e.svg";